import { Tag } from "@zapier/design-system";
import { Suspense } from "react";
import { useAtomValue } from "jotai";
import { isZapEnabledAsyncAtomFamily } from "@zapier/canvas-state";

type Props = {
  zapId: string;
};

function SuspendedZapStatus({ zapId }: Props) {
  const isZapOn = useAtomValue(isZapEnabledAsyncAtomFamily(zapId));

  if (isZapOn !== null && !isZapOn) {
    return (
      <Tag variant="warning" size="small">
        Turned off
      </Tag>
    );
  }

  return null;
}

export function ZapStatus({ zapId }: Props) {
  return (
    <Suspense fallback={null}>
      <SuspendedZapStatus zapId={zapId} />
    </Suspense>
  );
}
